import React from 'react';
import { Code, Target, Zap, Shield } from 'lucide-react';

const features = [
  {
    icon: Code,
    title: 'Clean Code',
    description: 'Generate semantic, well-structured HTML code that follows best practices.'
  },
  {
    icon: Target,
    title: 'Multiple Components',
    description: 'Choose from various components like forms, layouts, and navigation.'
  },
  {
    icon: Zap,
    title: 'Instant Generation',
    description: 'Get your HTML code in seconds with our AI-powered tool.'
  },
  {
    icon: Shield,
    title: 'Best Practices',
    description: 'Code that follows accessibility and SEO guidelines.'
  }
];

export default function HTMLFeatures() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Why Choose Our HTML Generator?
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 rounded-lg border border-blue-200 hover:shadow-lg transition-shadow">
              <feature.icon className="w-12 h-12 text-blue-500 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}